import { useState, useEffect, useCallback } from 'react';
import { getApiClient } from '../api/client';

export interface DashboardStats {
  products_with_ar: number;
  total_ar_views: number;
  generation_success_rate: number;
  failed_generations: number;
  processing_generations: number;
}

export function useDashboard() {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchStats = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const client = getApiClient();
      const { data } = await client.get<DashboardStats>('/api/dashboard/stats');
      setStats(data);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to fetch dashboard stats'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return {
    stats,
    loading,
    error,
    refetch: fetchStats,
  };
}

